module.exports = __webpack_public_path__ + "img/24 hour front desk.6ca8a5ed.jpeg";